exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footview{margin:0;text-align:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;background-color:#f7f9fa}.site-footer{background-color:#f5f5f5;padding:20px 0}.footer-logo img{max-width:70px}.footer-title{text-align:left;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5cf0ecc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FooterView.vue
// module id = 152
// module chunks = 0